import { useState, useEffect, useRef } from "react";
import {
  Modal,
  Checkbox,
  Select,
  Switch,
  Button,
  Form,
  Row,
  Col,
  Typography,
  Radio,
} from "antd";
import { aspectRatios, getImageFilterStyle, getWrapperDimensions, MAX_HEIGHT, MAX_WIDTH } from "./ImageEditorModal";
import Image from "../../Image";
import i18n from "../../../../../language";
import { filteredTemplates } from "./LeftSidebar/TemplatesTab";
import NewLineUp from "../../../../frontend/templates/fcb/LineupNew/LineupForEdit";
import { useGlobalStore } from "../../../../../stores/globalBackendStore";
import _ from "lodash";
import FCBResultsView from "../../../../frontend/templates/fcb/ResultsNew/Index";
import FCBHeatmapView from "../../../../frontend/templates/fcb/Heatmap/Index";
import FCBGoalView from "../../../../frontend/templates/fcb/Goal/Index";
import FCBTableView from "../../../../frontend/templates/fcb/ImageTable/Index";
import FCBSliderView1 from "../../../../frontend/templates/fcb/MatchdaySlider/Index";
import FCBSliderView2 from "../../../../frontend/templates/fcb/MatchdaySlider2/Index";
import FCBSliderView3 from "../../../../frontend/templates/fcb/MatchdaySlider3/Index";
import FCBSliderView4 from "../../../../frontend/templates/fcb/MatchdaySlider4/Index";

const { Title } = Typography;
const { Option } = Select;

const SaveModal = ({ show, onClose, handleOk, backendCfg, template, layers, effects, selectedLangs, selectedFormats, setSelectedFormats, setSelectedLangs, manualEntries, presetBgColor, presetGkColor }) => {
  const [preview, setPreview] = useState(true);
  const [form] = Form.useForm();
  const [selectedResolution, setSelectedResolution] = useState(null);
  const [previousRatio, setPreviousRatio] = useState(null);
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const template_name = _.get(template, "template_name");
  const templateSetup = _.find(apiSetup.templates, { name: template_name });
  const availableFormats = _.get(templateSetup, "formats", []);
  const handleSave = () => {
    handleOk();
    onClose();
  };

  useEffect(() => {
    if (show) {
      form.setFieldsValue({
        resolution: selectedFormats,
        format: "JPEG",
        saveTo: "template",
        languages: selectedLangs,
      });
    }
  }, [show, form]);

  const imageResolutions = [
    { label: "16:9", format: "1920x1080" },
    { label: "9:16", format: "1080x1920" },
    { label: "4:5", format: "1200x1500" },
  ];
  const languages = [
    { label: "English", value: "en" },
    // { label: "Deutsch", value: "de" },
    { label: "Arabic", value: "ar" },
    { label: "Spanish", value: "es" },
    { label: "Portuguese", value: "pt" },
  ];
  const updatedAtPrefix = new Date(template.updatedAt).getTime();
  let hashUpdate = "";

  const resolutionOptions = imageResolutions.map((res) => ({
    label: res.label,
    value: res.format,
    disabled: !availableFormats.includes(res.format),
  }));
  if (updatedAtPrefix > Date.now() - 1000 * 15) {
    hashUpdate = Date.now();
  }

  const [screenSize, setScreenSize] = useState({ width: MAX_WIDTH, height: MAX_HEIGHT });
  const prevRatioRef = useRef(null);

  useEffect(() => {
    const ratio = effects.ratio;
    setSelectedResolution(ratio);
    setPreviousRatio(ratio);
  }, [effects])

  useEffect(() => {
    const scaledDimensions = getWrapperDimensions(selectedResolution);
    setScreenSize(scaledDimensions);
  }, [selectedResolution])

  const showLayers = !filteredTemplates.includes(template.template_name);
  const currentFormat = selectedResolution === 0.56 ? "1080x1920" : selectedResolution === 0.8 ? "1200x1500" : "1920x1080";
  return (
    <Modal
      title="Save"
      open={show}
      onCancel={onClose}
      footer={null}
      width={preview ? 1050 : 480} // Dynamically adjust modal width
      centered
      zIndex={3000}
      getContainer={() => document.getElementById("custom-modal-container")}
    >
      <div style={{ display: "flex", gap: 24 }}>
        <div style={{ flex: 1, height: 555 }}>
          <Form form={form} layout="vertical" style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center'
          }}>
            <Form.Item label="Image Resolution" name="resolution">
              <Checkbox.Group
                options={resolutionOptions}
                // defaultValue={selectedFormats}
                style={{ display: "flex", gap: 16 }}
                onChange={(values) => setSelectedFormats(values)}
              />
            </Form.Item>

            <Form.Item label="Format" name="format">
              <Select>
                <Option value="JPEG">JPEG</Option>
                <Option value="PNG">PNG</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Save to" name="saveTo">
              <Radio.Group>
                <Radio value="template">Template Folder</Radio>
                <Radio value="local">Local Drive</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item label="Content language" name="languages">
              <Checkbox.Group
                options={languages}
                style={{ display: "flex", flexWrap: "wrap", gap: "8px 16px" }}
                // defaultValue={selectedLangs}
                onChange={(values) => setSelectedLangs(values)}
              />
            </Form.Item>

            <Button
              type="primary"
              block
              style={{ marginTop: 24 }}
              onClick={() => handleSave()}
            >
              Save
            </Button>
          </Form>
        </div>

        {preview && (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "24px 16px",
              display: 'flex',
              flexDirection: 'column',
              height: 750,
              width: 650,
              alignItems: 'center'
            }}
          >
            <div style={{ display: "flex", width: '100%', alignItems: 'center', marginBottom: 16 }}>

              <h3 style={{ fontSize: 16, fontWeight: 400, marginRight: 24 }}>
                Preview
              </h3>
              <div
                style={{
                  display: "flex",
                  gap: 12,
                }}
              >
                {aspectRatios.map(({ format, label, url, selectedUrl, ratio }) => {
                  const selected = ratio === selectedResolution;
                  const isDisabled = !availableFormats.includes(format)
                  let d =
                    selectedResolution == 0.8 ? "image-full-height" : "null";
                  return (
                    <div
                      key={label}
                      onClick={() => {
                        if (!isDisabled) setSelectedResolution(ratio);
                      }}
                      style={{
                        padding: "6px 12px",
                        fontSize: 12,
                        fontWeight: 500,
                        color: isDisabled
                          ? "#ccc"
                          : selected
                            ? "#1677ff"
                            : "#999",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        cursor: isDisabled ? "not-allowed" : "default",
                        opacity: isDisabled ? 0.5 : 1,
                      }}
                    >
                      <img
                        src={selected ? selectedUrl : url}
                        style={{
                          marginBlock: "3px",
                          opacity: isDisabled ? 0.5 : 1,
                        }}
                      />
                      {label}
                    </div>
                  );
                })}
              </div>
            </div>

            <div
              style={{
                height: `${screenSize.height}px`,
                width: `${screenSize.width}px`,
                backgroundColor: "#fff",
                borderRadius: 8,
                overflow: "hidden",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
              }}
              className={`save-canvas-preview-img`}
            >
              {
                showLayers &&
                <div className={`comp-template-preview f-${currentFormat}`}>
                  <div className={"template-container"}>
                    {
                      template.template_name === 'fcb_results' ?

                        <FCBResultsView
                          data={{
                            ...template,
                            data: {
                              ...template.data,
                              editData: {
                                layers,
                                effects: {
                                  ...effects,
                                  ratio: previousRatio
                                },
                                manualEntries
                              },

                            }
                          }}
                          format={currentFormat}
                          prevRatio={previousRatio}
                        /> : template.template_name === 'fcb_goal' ? <FCBGoalView
                          data={{
                            ...template,
                            data: {
                              ...template.data,
                              editData: {
                                layers,
                                effects: {
                                  ...effects,
                                  ratio: previousRatio
                                },
                              },

                            }
                          }}
                          isEdit={true}
                          format={currentFormat}
                          prevRatio={previousRatio} /> : template.template_name === "fcb_image_table" ? <FCBTableView
                            data={{
                              ...template,
                              data: {
                                ...template.data,
                                editData: {
                                  layers,
                                  effects: {
                                    ...effects,
                                    ratio: previousRatio
                                  },
                                  manualEntries
                                },

                              }
                            }}
                            format={currentFormat}
                            prevRatio={previousRatio}
                          /> : template.template_name === 'fcb_matchday_slider_1' ? <FCBSliderView1
                            data={{
                              ...template,
                              data: {
                                ...template.data,
                                editData: {
                                  layers,
                                  effects: {
                                    ...effects,
                                    ratio: previousRatio
                                  },
                                  manualEntries
                                },

                              }
                            }}
                            format={currentFormat}
                            prevRatio={previousRatio}
                          /> :  template.template_name === 'fcb_matchday_slider_2' ? <FCBSliderView2
                            data={{
                              ...template,
                              data: {
                                ...template.data,
                                editData: {
                                  layers,
                                  effects: {
                                    ...effects,
                                    ratio: previousRatio
                                  },
                                  manualEntries
                                },

                              }
                            }}
                            format={currentFormat}
                            prevRatio={previousRatio}
                          /> : template.template_name === 'fcb_matchday_slider_3' ? <FCBSliderView3
                            data={{
                              ...template,
                              data: {
                                ...template.data,
                                editData: {
                                  layers,
                                  effects: {
                                    ...effects,
                                    ratio: previousRatio
                                  },
                                  manualEntries
                                },

                              }
                            }}
                            format={currentFormat}
                            prevRatio={previousRatio}
                          /> : template.template_name === 'fcb_matchday_slider_4' ? <FCBSliderView4
                            data={{
                              ...template,
                              data: {
                                ...template.data,
                                editData: {
                                  layers,
                                  effects: {
                                    ...effects,
                                    ratio: previousRatio
                                  },
                                  manualEntries
                                },

                              }
                            }}
                            format={currentFormat}
                            prevRatio={previousRatio}
                          /> : <FCBHeatmapView
                          data={{
                            ...template,
                            data: {
                              ...template.data,
                              editData: {
                                layers,
                                effects: {
                                  ...effects,
                                  ratio: previousRatio
                                },
                              },

                            }
                          }}
                          isEdit={true}
                          format={currentFormat}
                          prevRatio={previousRatio} />
                    }
                  </div>
                </div>
              }

              {
                !showLayers &&
                <div className={`comp-template-preview f-${currentFormat}`}>
                  <div className={"template-container"}>
                    <NewLineUp data={template} format={currentFormat} presetBgColor={presetBgColor} manualEntries={manualEntries} presetGkColor={presetGkColor} hasCLStars={effects?.hasCLStars} />
                  </div>
                </div>
              }

            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SaveModal;
